import React from 'react';
import Img from 'gatsby-image';
import { H3 } from '/src/components/wrapper/h';

export default (props) => {
	const { events } = props;
	return (
		<>
			{events.map((event, index) => {
				return (
					<section key={event.id} className='distance'>
						<H3 id={event.id} style={{ fontWeight: 'bold' }}>
							{event.strDate}開始分
						</H3>
						<Img fluid={event.fluid} alt={`${event.strDate}開始分の商品`} />
					</section>
				);
			})}
		</>
	);
};
